module.exports = __webpack_public_path__ + "static/media/report_active.9da206c9.svg";